import { render, staticRenderFns } from "./AsCollapse.vue?vue&type=template&id=5819f91a&scoped=true"
import script from "./AsCollapse.vue?vue&type=script&lang=ts"
export * from "./AsCollapse.vue?vue&type=script&lang=ts"
import style0 from "./AsCollapse.vue?vue&type=style&index=0&id=5819f91a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5819f91a",
  null
  
)

export default component.exports